/*
 * TriggerTimeline Reducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 11-Mar-2025
 */

import { produce } from 'immer'
import { actionTypes } from '../actions/triggerTimeline'
import { nullSafe } from 'Utility/globalMethods'

const ACTION_HANDLERS = {
  [actionTypes.DO_SHOW_TTL]: produce((draft, action) => {
    draft.ttlKey = action.key
    // Quando mostriamo il TTL KitStart, mark che l'ha visto
    if (action.key === 'KIT_START') {
      draft.hasViewedKitStartTtl = true
    }
  }),
  [actionTypes.DO_HIDE_TTL]: produce((draft, action) => {
    draft.ttlKey = ''
    draft.recallTTL = nullSafe(() => action.payload.recallTTL, false)
    // Mantieni il flag che l'utente ha visto il TTL
    // Non resettiamo hasViewedKitStartTtl qui
  }),
  [actionTypes.GET_RETRIEVE_TTL_REQUEST]: produce((draft) => {
    draft.recallTTL = false
  }),
  [actionTypes.GET_RETRIEVE_TTL_SUCCESS]: produce((draft, action) => {
    draft.current = action.response.triggerTimeline
  }),
  [actionTypes.GET_RETRIEVE_TTL_FAILURE]: produce((draft, action) => {
    // TBD
  }),
  [actionTypes.SET_RETRIEVE_TTL_READ_REQUEST]: produce((draft) => {
    draft.isTTLread = false
  }),
  [actionTypes.SET_RETRIEVE_TTL_READ_SUCCESS]: produce((draft) => {
    draft.isTTLread = true
  }),
  [actionTypes.GET_COMUNICATION_DETAIL_SUCCESS]: produce((draft, action) => {
    draft.homeComunication = nullSafe(() => action.response, {})
  }),
  [actionTypes.DO_RESET_HOME_COMUNICATION]: produce((draft) => {
    draft.homeComunication = {}
  }),
  [actionTypes.GET_KITSTART_DATA_REQUEST]: produce((draft) => {
    draft.kitStartDataLoading = true
  }),
  [actionTypes.GET_KITSTART_DATA_SUCCESS]: produce((draft, action) => {
    draft.kitStartDataLoading = false
    draft.kitStartData = nullSafe(() => action.response, {})
  }),
  [actionTypes.GET_KITSTART_DATA_FAILURE]: produce((draft) => {
    draft.kitStartDataLoading = false
    draft.kitStartData = {}
  })
  // @generator reducer:type:action

}

// The initial state of the triggerTimeline
const initialState = {
  current: {},
  ttlKey: '',
  recallTTL: false,
  homeComunication: {},
  isTTLread: false,
  kitStartData: {},
  kitStartDataLoading: false,
  hasViewedKitStartTtl: false // Flag per tracciare se l'utente ha visto il TTL KitStart
}

const triggerTimeline = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default triggerTimeline
